:host {
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}
